import { CSSProperties, ReactNode } from 'react';
import {
  AppBar as MUIAppBar,
  AppBarProps as MUIAppBarProps,
} from '@mui/material';

type AtomMUIProps = {
  children?: ReactNode;
  style?: CSSProperties;
  position?: 'fixed' | 'absolute' | 'sticky' | 'static' | 'relative';
};

export type AppBarProps = AtomMUIProps;

export const AppBar = (props: AppBarProps) => {
  const MUIProps: MUIAppBarProps = props;

  return <MUIAppBar {...MUIProps} />;
};

export default AppBar;
